import { Phone, Mail, Linkedin, Smartphone, Building2 } from "lucide-react";
import { Badge } from "../ui/badge";

const CHANNELS = [
  { key: "direct_phone", icon: Phone, label: "Direct Phone", field: "work_direct_phone" },
  { key: "mobile", icon: Smartphone, label: "Mobile", field: "mobile_phone" },
  { key: "work_email", icon: Mail, label: "Work Email", field: "work_email" },
  { key: "personal_email", icon: Mail, label: "Personal Email", field: "personal_email" },
  { key: "linkedin", icon: Linkedin, label: "LinkedIn", field: "linkedin_url" },
  { key: "company_phone", icon: Building2, label: "Company", field: "work_company_phone" },
];

export default function ChannelPriority({ lead, bestChannel }) {
  const available = CHANNELS.filter(ch => lead[ch.field]);
  if (available.length === 0) return <span className="text-xs text-muted-foreground">No contact channels</span>;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {available.map((ch) => {
        const Icon = ch.icon;
        const isBest = ch.key === bestChannel;
        return (
          <Badge
            key={ch.key}
            variant={isBest ? "default" : "outline"}
            className={`text-xs gap-1 ${isBest ? "" : "opacity-60"}`}
          >
            <Icon className="h-3 w-3" />
            {ch.label}
            {isBest && <span className="text-[10px] ml-0.5">★</span>}
          </Badge>
        );
      })}
    </div>
  );
}
